// extracted by mini-css-extract-plugin
export default {"popUpwindow":"PopUpSent_popUpwindow__fPX0C","btn":"PopUpSent_btn__oT-xt","success":"PopUpSent_success__mTDpy","failure":"PopUpSent_failure__zH17r","hide":"PopUpSent_hide__W9kIW"};